import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppDispatch } from '../redux-store'
import { ProfileDatasAPI } from '../../api/api'

export interface ProfileIdentifierActionTypes {
    identified: boolean,
    success: number | null,
    error: number | null
}

export interface GetProfileIdentifierTypes {
    phone: string
}

export interface ProfileTrashDataActionTypes {
    trashed: boolean,
    success: number | null,
    error: number | null
}

export interface GetProfileTrashDataTypes {
    code: number
}

interface InitialStateTypes {
    identified: boolean,
    trashed: boolean,
    
    step: number,

    success: number | null,
    error: number | null

    errorMessage: string | null,
    isFetching: boolean
}

let initialState: InitialStateTypes = {
    identified: false,
    trashed: false,
    
    step: 1,
    
    success: null,
    error: null,

    errorMessage: null,
    isFetching: true
}

export const profileTrashDataSlice = createSlice({
    name: 'profileTrashData',
    initialState,
    reducers: {
        identifyStart(state) {
            state.isFetching = true
            state.identified = false
            state.success = null
            state.error = null
            state.errorMessage = null
        },
        identifySuccess(state, action: PayloadAction<ProfileIdentifierActionTypes>) {
            state.isFetching = false
            state.identified = action.payload.identified
            state.success = action.payload.success
            state.error = action.payload.error
        },
        identifyError(state, action: PayloadAction<string>) {
            state.isFetching = false
            state.errorMessage = action.payload
        },

        trashStart(state) {
            state.isFetching = true
            state.trashed = false
            state.success = null
            state.error = null
            state.errorMessage = null
        },
        trashSuccess(state, action: PayloadAction<ProfileTrashDataActionTypes>) {
            state.isFetching = false
            state.trashed = action.payload.trashed
            state.success = action.payload.success
            state.error = action.payload.error
        },
        trashError(state, action: PayloadAction<string>) {
            state.isFetching = false
            state.errorMessage = action.payload
        },
        
        setStep(state, action: PayloadAction<number>) {
            state.step = action.payload
        },
        setIdentified(state, action: PayloadAction<boolean>) {
            state.identified = action.payload
        },
        setTrashed(state, action: PayloadAction<boolean>) {
            state.trashed = action.payload
        },
        setSuccess(state, action: PayloadAction<number | null>) {
            state.success = action.payload
        },
        setError(state, action: PayloadAction<number | null>) {
            state.error = action.payload
        },
        setErrorMessage(state, action: PayloadAction<string | null>) {
            state.errorMessage = action.payload
        }
    }
})

export const setStep = (step: number) => profileTrashDataSlice.actions.setStep(step)
export const setIdentified = (identified: boolean) => profileTrashDataSlice.actions.setIdentified(identified)
export const setTrashed = (trashed: boolean) => profileTrashDataSlice.actions.setTrashed(trashed)
export const setSuccess = (success: number | null) => profileTrashDataSlice.actions.setSuccess(success)
export const setError = (error: number | null) => profileTrashDataSlice.actions.setError(error)
export const setErrorMessage = (errorMessage: string | null) => profileTrashDataSlice.actions.setErrorMessage(errorMessage)

// IDENTIFIER
export const identifier = ({
        phone
    }: GetProfileIdentifierTypes
) => async (dispatch: AppDispatch) => {
    try {
        dispatch(profileTrashDataSlice.actions.identifyStart())
        let response = await ProfileDatasAPI.identifier({
            phone
        })
        dispatch(profileTrashDataSlice.actions.identifySuccess(response.data))
    } catch (error: any) {
        dispatch(profileTrashDataSlice.actions.identifyError(error.message))
    }
}

// TRASH PROFILE
export const trashData = ({
        code
    }: GetProfileTrashDataTypes
) => async (dispatch: AppDispatch) => {
    try {
        dispatch(profileTrashDataSlice.actions.trashStart())
        let response = await ProfileDatasAPI.trash({
            code
        })
        dispatch(profileTrashDataSlice.actions.trashSuccess(response.data))
    } catch (error: any) {
        dispatch(profileTrashDataSlice.actions.trashError(error.message))
    }
}

export default profileTrashDataSlice.reducer